import { useDispatch } from "react-redux";
import React, { useCallback } from "react";
import {
  FinancialStatementForm,
  FinancialStatementFormValues,
} from "components/MultiSaleReports/ManyReportsForm/FinancialStatementReports/Form";
import { ReportJobAction } from "actions/reportJob";
import { Form, Formik } from "formik";
import { validationSchema } from "components/MultiSaleReports/ManyReportsForm/FinancialStatementReports";
import { Grid } from "@material-ui/core";
import { ModalActions } from "components/MultiSaleReports/ManyReportsForm/BulkReportFormCommon";

interface FormValues extends FinancialStatementFormValues {
  report: "FinancialStatementReport";
  businessIds: string[];
}

interface BusinessFinancialStatementFormProps {
  businessIds: string[];
  onClose: () => void;
  reportSlug: "FinancialStatementReport";
}

export function BusinessFinancialStatementForm(
  props: BusinessFinancialStatementFormProps,
) {
  const { businessIds, onClose, reportSlug } = props;
  const dispatch = useDispatch();

  const onSubmit = useCallback(
    (values: FormValues) => {
      dispatch(ReportJobAction.createBulk(values));
      onClose();
    },
    [dispatch, onClose],
  );

  const initialValues: FormValues = {
    businessIds,
    report: reportSlug,
    startDate: null,
    endDate: null,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Grid container spacing={2}>
          <FinancialStatementForm />
        </Grid>
        <ModalActions onClose={onClose} allowInitialSubmit={false} />
      </Form>
    </Formik>
  );
}
